import Grid from '@mui/material/Grid'
import { AlarmIcon, CloseIcon } from 'assets/icons'
import IconButton from 'components/buttons/IconButton'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { reminderUserTitle } from 'components/popups/eventInfo/AddReminderPopup'
import CustomEventReminderPopup from 'components/popups/eventInfo/CustomEventRecurrencePopup'
import { useState } from 'react'
import { EventDoc, EventReminder } from 'types/api/changes'

interface RemindersListProps {
  reminders: EventReminder[]
  setReminders: (reminders: EventReminder[]) => void
  event?: EventDoc
}

export default function RemindersList(props: RemindersListProps) {
  const [showCustom, setShowCustom] = useState<number | string | undefined>(
    undefined
  )

  return (
    <Grid container flexDirection={'column'} display={'flex'}>
      {(props.reminders ?? [])
        ?.sort((a, b) => Number(a.offset) - Number(b.offset))
        ?.map((reminder) => {
          const reminderKey = `${reminder.offset}:${reminder.AlertTime ?? ''}:${reminder.isRelativeReminder ?? ''}`

          const removeReminder = () => {
            props.setReminders(
              props.reminders.filter((rem) => {
                if (reminder.AlertTime) {
                  return rem.AlertTime !== reminder.AlertTime
                }

                return rem.offset !== reminder.offset
              })
            )
            setShowCustom(undefined)
          }

          return (
            <PopupSectionRow
              key={reminderKey}
              icon={<AlarmIcon />}
              cursor="default"
              flexGrowForRow={1}
              actionBg
              action={() => {
                if (reminder.AlertTime) setShowCustom(reminder.AlertTime)
                else setShowCustom(reminder.offset)
              }}
              title={
                <CustomEventReminderPopup
                  key={reminderKey}
                  open={
                    reminder.AlertTime
                      ? showCustom === reminder.AlertTime
                      : showCustom === reminder.offset
                  }
                  setOpen={(b: boolean) => {
                    console.log('setOpen', b)
                    if (!b) setShowCustom(undefined)
                  }}
                  event={props.event}
                  reminders={props.reminders}
                  setReminders={props.setReminders}
                  editingReminder={props.reminders.find((rem) => {
                    if (reminder.AlertTime) {
                      return rem.AlertTime === reminder.AlertTime
                    }

                    return rem.offset === reminder.offset
                  })}
                >
                  <span
                    style={{
                      width: 'fit-content'
                    }}
                  >
                    {reminderUserTitle(reminder, props.event?.AllDay === '1')}
                  </span>
                </CustomEventReminderPopup>
              }
              value={
                <IconButton
                  size="xs"
                  onClick={removeReminder}
                  stopPropagationOnClick
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          )
        })}
    </Grid>
  )
}
